module.exports = __webpack_public_path__ + "img/logo.6ae0bbaf.png";